import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './PanierPage.scss'
import BaseButton from "../../Components/BaseButton/BaseButton";
import {useLocation, useNavigate} from "react-router-dom";
import PanierItem from "../../Components/PanierItem/PanierItem";
import {useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {OrderModel, OrderProductModel} from "../../Models/OrderModel";
import {DoorModel} from "../../Models/DoorModel";
import {useUpdatePanier} from "../../hooks/useUpdatePanier";
import {useUpdateOrderWithoutDiscount} from "../../hooks/useUpdateOrderWithoutDiscount";
import {useUpdateOrderWithPercentDiscount} from "../../hooks/useUpdateOrderWithPercentDiscount";
import {useUpdateOrderWithQuantityDiscount} from "../../hooks/useUpdateOrderWithQuantityDiscount";
import {useModal} from "../../hooks/useModal";
import Confirm from "../../Components/Confirm/Confirm";
import {StadiumModel} from "../../Models/StadiumModel";
import CrossSelling from "../../Components/CrossSelling/CrossSelling";
import {useGetCrossSellingItems} from "../../hooks/useGetCrossSellingItems";
import {useGenerateReference} from "../../hooks/useGenerateReference";
import {ProductModel} from "../../Models/ProductModel";
import useHttpClient from "../../hooks/http/useHttpClient";
import Error from "../../Components/Error/Error";

const PanierPage: React.FC = ({}) => {
    const navigate = useNavigate()
    const {state} = useLocation() as { state: { fromItemPage?: boolean } }
    const {getProducts} = useHttpClient()

    const [products, setProducts] = useState<ProductModel[]>([])
    const userLoged = useSelector<StateModel, boolean>(state => state.user?.id !== undefined)
    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)
    const porte = useSelector<StateModel, DoorModel | undefined>(state => state.door)
    const pdv = useSelector<StateModel, number | undefined>(state => state.selectedPdv)
    const stadium = useSelector<StateModel, StadiumModel | undefined>(state => state.stadium)

    const [indexToDelete, setIndexToDelete] = useState<number | undefined>(undefined)
    const [wait, setWait] = useState<boolean>(true)

    const updatePanier = useUpdatePanier()
    const generateReference = useGenerateReference()
    const updateOrderWithoutDiscount = useUpdateOrderWithoutDiscount()
    const updateOrderWithPercentDiscount = useUpdateOrderWithPercentDiscount()
    const updateOrderWithQuantityDiscount = useUpdateOrderWithQuantityDiscount()
    const showConfirm = useModal()
    const showCrossSelling = useModal()
    const quantiteModifieModal = useModal()
    const quantiteInsufisanteModal = useModal()

    const crossSellingProducts = useGetCrossSellingItems(panier)

    useEffect(() => {
        void generateReference().then(() => setWait(false))
        if(pdv) {
            void getProducts(''+pdv).then((response: ProductModel[]) => {
                setProducts(response)
                let quantitModifie = false
                panier?.orderProducts?.forEach((orderProduct: OrderProductModel, index: number) => {
                    const product = response.find(p => p.product.id === orderProduct.product.id)
                    if(product?.stockAvailable === 0) {
                        quantitModifie = true
                        deleteProduct(index)
                    } else if(product && orderProduct.quantity && orderProduct.quantity > product.stockAvailable) {
                        quantitModifie = true
                        while (orderProduct.quantity > product.stockAvailable) {
                            handleQuantityClick(index, false)
                        }
                    }
                })
                if(quantitModifie) {
                    quantiteModifieModal.open()
                }
            })
        }
    }, [])

    const handleQuantityClick = (index: number, plus: boolean) => {
        if(plus) {
            if(panier?.orderProducts) {
                const orderProduct = panier.orderProducts[index]
                const product = products.find(p => p.product.id === orderProduct.product.id)

                const quantity = orderProduct.quantity ?? 0
                const availableStock = product?.stockAvailable ?? 0

                if(quantity < availableStock) {
                    updateOrderProduct(index, plus)
                } else {
                    quantiteInsufisanteModal.open()
                }
            }
        } else {
            updateOrderProduct(index, plus)
        }
    }
    const updateOrderProduct = (index: number, plus: boolean) => {
        const newPanier = {...panier} || {}
        if(!newPanier.orderProducts) {
            newPanier.orderProducts = []
        }
        const quantity = newPanier.orderProducts[index].quantity || 0
        newPanier.orderProducts[index].quantity = plus ? quantity + 1 : quantity - 1

        const newOrderProducts: OrderProductModel[] = []

        newPanier.orderProducts.map(p => {return {...p, totalPriceHT: 0, totalPriceTTC: 0, totalTva: 0, discount: 0}}).forEach((p) => {
            if(!p.discountType) {
                newOrderProducts.push(updateOrderWithoutDiscount(p, p.quantity || 0))
            } else if(p.discountType === 'percent') {
                newOrderProducts.push(updateOrderWithPercentDiscount(p, p.quantity || 0))
            } else {
                newOrderProducts.push(updateOrderWithQuantityDiscount(p, p.quantity || 0, newOrderProducts))
            }
        })

        newPanier.orderProducts = newOrderProducts
        updatePanier(newPanier)
    }

    const handleDeleteClick = (index: number) => {
        setIndexToDelete(index)
        showConfirm.open()
    }

    const deleteProduct = (index?: number) => {
        if(index !== undefined) {
            const newPanier = {...panier} || {}
            if(!newPanier.orderProducts) {
                newPanier.orderProducts = []
            }

            const newOrderProducts = [...newPanier.orderProducts]
            newOrderProducts.splice(index, 1)
            newPanier.orderProducts = newOrderProducts
            updatePanier(newPanier)
            showConfirm.close()
            setIndexToDelete(undefined)
        }
    }


    const handleClick = () => {
        if(porte) {
            navigate(`/stands?stadium=${stadium?.reference}&doorId=${porte.id}`)
        } else {
            navigate(`/menu?stadium=${stadium?.reference}&pdvId=${pdv}`)
        }
    }

    const handlePaiementClick = () => {
        if(crossSellingProducts.length > 0) {
            showCrossSelling.open();
        } else {
            navigate(userLoged ? '/paiement' : '/commande')
        }
    }

    const getItemToDeleteQuantity = (): number => {
        return panier?.orderProducts && indexToDelete !== undefined ? panier.orderProducts[indexToDelete].quantity || 0 : 0
    }

    return (
        <BasePage showBack title="Panier" showHistorique onBack={() => navigate(state?.fromItemPage ? -2 : -1)}>
            <>
                {
                    panier?.orderProducts && panier.orderProducts.length > 0 ? (
                        <>
                            <div className="panier">
                                {
                                    panier.orderProducts?.map((item, index) => (
                                        <PanierItem
                                            key={index}
                                            item={item}
                                            onMinusClick={() => item.quantity && item.quantity > 1 && handleQuantityClick(index, false)}
                                            onPlusClick={() => handleQuantityClick(index, true)}
                                            onDeleteClick={() => handleDeleteClick(index)}
                                        />
                                    ))
                                }
                            </div>
                            <div className="panierFooter">
                                <div className="panierFooter__infos">
                                    <p className="panierFooter__infos--total">Total</p>
                                    <p className="panierFooter__infos--totalTxt">{panier.totalPriceTTC} €</p>
                                </div>
                                <BaseButton disabled={wait} onClick={handlePaiementClick} text="Paiement" className="panierFooter--btn"/>
                            </div>
                        </>
                    ) : (
                        <div className="panierVide">
                            <p className="panierVide--title">Votre panier est vide</p>
                            <p className="panierVide--text">Commandez vos articles en cliquant sur le bouton ci-dessous</p>
                            <BaseButton onClick={handleClick} text="Voir les articles" type="filled" className="panierVide--btn" />
                        </div>
                    )
                }
                <Confirm
                    visible={showConfirm.visible}
                    title="Voulez vous supprimer cet article ?"
                    subTitle={getItemToDeleteQuantity()  > 1 ? `${getItemToDeleteQuantity()} articles` : '1 article'}
                    onOk={() => deleteProduct(indexToDelete)}
                    onCancel={showConfirm.close}
                />
                <CrossSelling show={showCrossSelling.visible} close={showCrossSelling.close} products={crossSellingProducts} />
                <Error
                    show={quantiteInsufisanteModal.visible}
                    close={quantiteInsufisanteModal.close}
                    title={`Quantité insufisante`}
                    subTitle="La quantitée demandée dépasse le stock du produit."
                    btnTxt="Compris"
                />
                <Error
                    show={quantiteModifieModal.visible}
                    close={quantiteModifieModal.close}
                    title={`Quantité insufisante`}
                    subTitle="Le stock de certains produits sont inférieure à la quantité demandée, les quantités ont été modifiées."
                    btnTxt="Compris"
                />
            </>
        </BasePage>
    )
}

export default PanierPage;
